module.exports = __webpack_public_path__ + "img/pg4-article2-c4.eade7c55.png";